module.exports = __webpack_public_path__ + "img/2.08139fc1.jpg";